import React from 'react';
import Markdown from 'react-markdown';
import { randomKey } from '../../core/util';

const TermsRenderer = ({ terms, termname }) =>
  terms?.length
    ? terms.map((paragraph, i) => {
        const reqPara =
          termname === 'electronicAccessDelivery' && i === 0
            ? `I. ${paragraph}`
            : paragraph;
        return <Markdown key={randomKey()}>{reqPara}</Markdown>;
      })
    : null;

export default TermsRenderer;
